import { createInvite } from '@wix/ambassador-identity-invites-v1-account-invite/http'

import { withMonitoring } from '../../monitoring/withMonitoring'
import { ambassadorHttpClient } from '../httpClient'
import { Invite } from './types'

export const createAccountInvites = async (invites: Invite[]) => {
  if (!invites.length) {
    return
  }

  const request = () =>
    ambassadorHttpClient.request(
      createInvite({
        subjectsAssignments: invites.map(invite => ({
          subjectEmail: invite.email,
          assignments: [{ policyId: invite.policyId }],
        })),
      }),
    )
  await withMonitoring(request, 'createInvite')
}
